module.exports = __webpack_public_path__ + "img/system3.1c282575.png";